<template>
    <div class="main-content">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 class="title mb-3" v-if="team && team.name">Team <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 11-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 111.254-1.255L12.74 9.39a.888.888 0 01-.16 1.382l-4.043 4.042z"/></svg> <span class="team-name"><router-link :to="{ name: 'Switch Team'}" class="text-blue blue-hover">{{ team.name }}</router-link></span></h1>
                    <div class="team-member-part">
                        <div class="team-member-btn">
                            <div class="delete-link">
                                <a href="javascript:;" @click="bulkRemove()">
                                    <svg width="18" height="22" xmlns="http://www.w3.org/2000/svg"><defs><filter id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"/></filter></defs><g transform="translate(-3 -.5)" filter="url(#a)" fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M19 7.25c.46 0 .811.41.741.864l-1.739 11.304a2.75 2.75 0 01-2.718 2.332H8.716a2.75 2.75 0 01-2.718-2.332L4.258 8.114A.75.75 0 015 7.25h14zM8.737 8.75H5.874L7.48 19.19a1.25 1.25 0 001.236 1.06h.544l-.523-11.5zm5.023 0h-3.521l.523 11.5h2.475l.523-11.5zm4.366 0h-2.864l-.523 11.5h.545a1.25 1.25 0 001.236-1.06l1.606-10.44zm-2.379-7.455a1 1 0 01.994.883l.006.117V4.75h3.003a.75.75 0 01.102 1.493l-.102.007H3.978a.75.75 0 01-.102-1.493l.102-.007h3.337V2.295a1 1 0 01.883-.993l.117-.007h7.432zM15.25 2.75h-6.5v2h6.5v-2z" fill="#6E7077" fill-rule="nonzero"/></g></svg>
                                </a>
                            </div>
                            <a href="javascript:;" class="btn btn-primary" @click="goToJoin()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12"><path fill="#fff" d="M6.099 0c.44 0 .796.336.796.75V5h4.514c.44 0 .796.336.796.75s-.356.75-.796.75H6.895v4.25c0 .414-.356.75-.796.75-.44 0-.797-.336-.797-.75V6.5H.79c-.44 0-.797-.336-.797-.75S.35 5 .79 5h4.513V.75c0-.414.357-.75.797-.75z"/></svg>
                                Add Member
                            </a>
                        </div>
                        <div class="team-member-search">
                            <div class="custom-control custom-checkbox" v-cloak>
                                <input type="checkbox" class="custom-control-input" @click="toggleAll($event)" id="all" :indeterminate.prop="bulk_select.length && bulk_select.length < members_count" :checked="bulk_select.length && bulk_select.length == members_count && bulk_select.length > 0">
                                <label class="custom-control-label" for="all"></label>
                            </div>
                            <div class="team-search">
                                    <a class="close-btn" v-if="search" @click="search = ''; filteredMembers();"></a>
                                    <input type="text" v-model="search" placeholder="Search team members…" @keyup.enter="filteredMembers();" @keyup.esc="search = ''; filteredMembers();">
                                    <button @click="filteredMembers();" :disabled="!search"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g><g><path fill="#6E7077" d="M14.108 7.054a7.054 7.054 0 1 0-2.609 5.477l5.255 5.255a.73.73 0 0 0 1.032-1.032L12.531 11.5a7.025 7.025 0 0 0 1.577-4.445zm-12.649 0a5.595 5.595 0 1 1 11.19 0 5.595 5.595 0 0 1-11.19 0z"/></g></g></svg></button>
                            </div>
                            <div class="team-member-role">
                                <span>Role</span>
                            </div>
                        </div>
                        <div class="team-member-list" v-if="members.length" v-for="member in members">
                            <div class="custom-control custom-checkbox" v-if="permissionCheck(member)">
                                <input type="checkbox" class="custom-control-input" :id="'customCheck' + member.id"
                                    v-on:change="selectMember($event, member.id)"
                                    :checked="member.checked">
                                <label class="custom-control-label" :for="'customCheck' + member.id"></label>
                            </div>
                            <div class="profile-author">
                                <div class="user-img">
                                    <avatar v-bind:username="member.user.name"  v-bind:src="'/storage/' + member.user.photo" v-if="member.user.name" :size="45"></avatar>
                                </div>
                                <p>{{ member.user.name }}</p>
                            </div>
                            <div class="team-member-role"
                                 @focusout="hideOption($event);"
                                 tabindex="1">
                                <span style="text-transform: capitalize;">{{ member.team_role }}</span>
                                <div class="team-member-more" v-if="permissionCheck(member)">
                                    <a href="javascript:;" @click="toggleOption(member.user_id)" class="team-more-link pointer"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4"><g><g><path fill="#000" d="M6.5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-12 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"/></g></g></svg></a>
                                    <div class="team-more-dropdown" v-if="member.user_id == activeOption" style="display: block;"
                                         ref="memberOption"
                                    >
                                        <ul>
                                            <li><a href="javascript:;" @click="activeChangeRoleId = member.user_id;" >Change Role</a></li>
                                            <li><a href="javascript:;" @click="removeMember(member);">Delete</a></li>
                                        </ul>
                                        <div class="role-change" v-if="member.user_id == activeChangeRoleId">
                                            <ul>
                                                <li>
                                                    <a href="javascript:;" @click="changeRole(member, 'admin')" v-if="member.team_role == 'member'">Admin</a>
                                                    <a href="javascript:;" @click="changeRole(member, 'member')" v-else>Member</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="team-member-list" v-if="pending_members.length" v-for="pm in pending_members">

                            <div class="profile-author" v-if="pm.user_info">
                                <div class="user-img">
                                    <avatar v-bind:username="pm.user_info.name" v-bind:src="'/storage/' + pm.user_info.photo" v-if="pm.user_info.name" :size="45"></avatar>
                                </div>
                                <p>{{ pm.user_info.name }} ({{ pm.user_info.email }})</p>
                            </div>
                            <div class="profile-author" v-else>
                                <div class="user-img">
                                    <avatar v-bind:username="pm.email"  v-if="pm.email" :size="45"></avatar>
                                </div>
                                <p>{{ pm.email }}</p>
                            </div>
                            <div class="team-member-role"
                                 @focusout="hideOption($event);"
                                 tabindex="1">
                                <span style="text-transform: capitalize; color: #1e73bd;">Pending</span>
                                <div class="team-member-more">
                                    <a href="javascript:;" @click="toggleOption(pm.id)" class="team-more-link pointer"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4"><g><g><path fill="#000" d="M6.5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-12 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"/></g></g></svg></a>
                                    <div class="team-more-dropdown" v-if="pm.id == activeOption" style="display: block;">
                                        <ul>
                                            <li><a href="javascript:;" @click="deleteInvite(pm);">Delete invite</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
        <v-dialog />

    </div>
</template>

<script>
import ApiService from "../../api/api.service";
import {mapGetters} from "vuex";
import Avatar from "vue-avatar";
import vmodal from 'vue-js-modal'

export default {
    name: "TeamIndex",
    components: {
        Avatar,
        vmodal
    },
    data() {
        return {
            team: null,
            members: null,
            activeOption: null,
            activeChangeRoleId: null,
            user: null,
            user_role: 'owner',
            select_all: null,
            search: '',

            members_count: 0,
            bulk_select: [],


            pending_members: [],
        };
    },
    mounted() {
        // get user details
        this.getUser();
    },
    methods: {
        getUser() {
            ApiService.setHeader();
            ApiService.get('/api/user').then(({data}) => {
                this.user = data;

                if(this.user.team_id) {
                    this.teamUsers(this.user.team_id);
                    this.pendingMembers(this.user.team_id);
                } else if(this.user.team_ids.length) {
                    this.$router.push({ name: 'Switch Team' });
                } else {
                    this.$router.push({ name: 'Create Team Intro' });
                }

                window.localStorage.setItem('user', JSON.stringify(data));
            }).catch(error => {
                throw new Error('failed to load user');
            });
        },

        teamUsers(teamId) {
            ApiService.setHeader();
            ApiService.get('/api/teams/' + teamId)
                .then(({data}) => {
                    this.team = data.team;
                    this.originalMembers = JSON.parse(JSON.stringify(data.team_members));
                    this.members = data.team_members;
                    this.members.forEach((m) => {
                        if(m.team_role != 'owner') {
                            this.members_count = this.members_count + 1;


                            if(m.user_id == this.user.id) {
                                this.user_role = m.team_role;

                                // Normal member does not have access
                                if(m.team_role == 'member') {
                                    this.$router.push({ name: 'Documents' });
                                }

                            }

                        }
                    })
                })
                .catch();
        },

        goToJoin() {
            this.$router.push({ name: 'Team Join'}); // team join
        },

        toggleOption(id) {
            if(this.activeOption == id) {
                this.activeOption = null;
                this.activeChangeRoleId = null;
            } else {
                this.activeOption = id;
            }
        },

        hideOption(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.activeOption = null;
                this.activeChangeRoleId = null;
            }
        },

        removeMember(member) {

            this.$modal.show('dialog', {
                title: '&nbsp;',
                text: '<p class="text-center">Are you sure you want to remove this user?</p> <p class="text-center">They will no longer have access to this team.</p>',
                buttons: [
                    {
                        title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: 'Delete',
                        handler: () => {
                            ApiService.setHeader();
                            ApiService.delete('/api/teams/' + member.user_id)
                                .then(({data}) => {
                                    if(data) {
                                        this.members = this.members.filter((m) => m.user_id !== member.user_id);
                                    }
                                    this.$modal.hide('dialog');
                                })
                                .catch();
                        }
                    }
                ]
            })


        },

        selectMember(e, id) {
            if(e.target.checked) {
                this.bulk_select.push(id);
            } else {
                let index = this.bulk_select.indexOf(id);
                if(index !== -1) {
                    this.bulk_select.splice(index, 1);
                }
            }

        },

        changeRole(member, role) {
            ApiService.setHeader();
            ApiService.post('/api/teams/change-role', {
                user_id: member.user_id,
                role: role
            })
                .then(({data}) => {
                    member.team_role = role;

                    this.activeOption = this.activeChangeRoleId = null;
                })
                .catch();
        },

        toggleAll(e) {

            this.members_count = 0;
            this.bulk_select = []

            if(e.target.checked) {
                this.members.forEach((m) => {
                    if(m.team_role != 'owner') {
                        this.members_count = this.members_count + 1;
                        this.bulk_select.push(m.id);
                        m.checked = true;
                    }
                })
            } else {
                this.members.forEach((m) => {
                    if(m.team_role != 'owner') {
                        m.checked = false;
                    }
                })
            }
        },

        bulkRemove() {
            if(this.bulk_select.length) {
                this.$modal.show('dialog', {
                    title: '&nbsp;',
                    text: '<p class="text-center">Are you sure you want to remove this user(s)?</p> <p class="text-center">They will no longer have access to this team.</p>',
                    buttons: [
                        {
                            title: 'Cancel',
                            handler: () => {
                                this.$modal.hide('dialog')
                            }
                        },
                        {
                            title: 'Delete',
                            handler: () => {
                                ApiService.setHeader();
                                ApiService.post('/api/teams/bulk-delete', { ids : this.bulk_select })
                                    .then(({data}) => {
                                        if(data) {
                                            this.members = this.members.filter((m) => this.bulk_select.indexOf(m.id) === -1);
                                            this.bulk_select = [];
                                        }

                                        this.$modal.hide('dialog');
                                    })
                                    .catch();
                            }
                        }
                    ]
                })
            } else {
                this.$modal.show('dialog', {
                    title: '&nbsp;',
                    text: '<p class="text-center">Please select a user to delete.</p>',
                    buttons: [
                        {
                            title: 'Okay',
                            handler: () => {
                                this.$modal.hide('dialog')
                            }
                        }
                    ]
                })
            }

        },

        filteredMembers() {
            const search = this.search.toLowerCase().trim();

            if(search) {
                this.members = this.originalMembers.filter(
                    member => member.user.name.toLowerCase().indexOf(search) > -1
                );
            } else {
                this.members = JSON.parse(JSON.stringify(this.originalMembers));
            }
        },

        pendingMembers(team_id) {
            let url = '/api/teams/invited-users/' + team_id;
            ApiService.setHeader();
            ApiService.get(url)
                .then(({data}) => {
                  this.pending_members = data.users;
                })
                .catch();
        },

        deleteInvite(pendingMember) {

            this.$modal.show('dialog', {
                title: '&nbsp;',
                text: '<p class="text-center">Are you sure you want to remove this user?</p> <p class="text-center">They will no longer have access to this team.</p>',
                buttons: [
                    {
                        title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: 'Delete',
                        handler: () => {
                            let url = '/api/teams/invite/delete';
                            ApiService.setHeader();
                            ApiService.post(url, {
                                team_id : this.team.id,
                                id: pendingMember.id
                            })
                                .then(({data}) => {
                                    this.pending_members = this.pending_members.filter((m) => m.id !== pendingMember.id);

                                    this.$modal.hide('dialog');
                                })
                                .catch();
                        }
                    }
                ]
            })


        },

        permissionCheck(member)
        {
            return member.team_role != 'owner' && member.user_id != this.user.id && (this.user_role == 'owner' || member.team_role == 'member');
        }
    }

}
</script>

<style scoped>
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
    top: 7px;
    left: 7px;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
    color: #fff;
    border-color: #23a6cd;
    background-color: #23a6cd !important;
}

.team-member-more .role-change{
    color: #000;
    font-size: 14px;
    position: absolute;
    right: 160px;
    top: 0px;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
    width: 100px;
    z-index: 2;
    background: #fff;
    border-radius: 6px;
    font-weight: 400;
    opacity: 1;
    transition: all 0.3s ease;
}
.team-more-dropdown ul li a {
    padding: 7px 27px;
}
.team-search input {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
}
.team-search a.close-btn {
    background: url(/assets/img/cross.svg) no-repeat scroll 10px 15px;
    background-size: 12px;
    padding-left: 30px;
    width: 50px;
    height: 100%;
    position: absolute;
    top: -3px;
    left: 15px;
    border: 0;
    border-radius: 0;
    transition: inherit;
    cursor: pointer;
}

a.btn-primary {
    border-radius: 20px;
}

.team-member-btn a:hover svg path{
    fill: #1e73bd;
}
.team-member-btn .delete-link a:hover svg path:first-child {
    fill: none;
}
h1.title svg {
    width: 20px;
}
h1.title span.team-name {
    color: #1e73bd;
}
a.blue-hover:hover {
    color: #23a6cd;
}
</style>
